import script from "./AddShippingMethod.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddShippingMethod.vue?vue&type=script&setup=true&lang=ts"

import "./AddShippingMethod.vue?vue&type=style&index=0&id=42b872b6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42b872b6"]])

export default __exports__